import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ICrewMember } from '../models/crew-member.model';

@Injectable({
  providedIn: 'root'
})
export class CrewTimecardService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getAllLayouts() {
    let url = "/CrewTimecard/GetAllLayouts";
    return this.http.get(url).toPromise();
  }

  getBulkEmployeeList(pRCo, pRGroup) {
    let url = "/CrewTimecard/GetBulkEmployeeList?pRCo=" + pRCo + "&pRGroup=" + pRGroup;
    return this.http.get(url).toPromise();
  }

  getCellPossibleValues(rowData) {
    let url = "/Timecard/GetCellPossibleValues";
    return this.http.post(url, rowData).toPromise();
  }
  getCellPossibleValuesByEmployee(columnName: string, pRPCKeyID, employee = null, prehKeyID = null) {
    let url = "/Timecard/GetCellPossibleValues?column=" + columnName + "&payPeriod=" + pRPCKeyID;
    if (employee != null)
      url += "&employee=" + employee;
    if (prehKeyID != null)
      url += "&prehKeyID=" + prehKeyID;
    return this.http.post(url, prehKeyID).toPromise();
  }

  getCrewClockInStatus(pRPCKeyID, crewTemplateID) {
    let url = "/CrewTimecard/GetCrewClockInStatus?pRPCKeyID=" + pRPCKeyID + "&crewTemplateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getEmplLockStatus(hQBCKeyID, crewTemplateID) {
    let url = "/CrewTimecard/GetEmplLockStatus?hQBCKeyID=" + hQBCKeyID + "&crewTemplateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getJobsByAuthToken(form, searchString) {
    let url = "/CrewTimecard/GetJobsByAuthToken?form=TC&searchString=" + searchString;
    return this.http.get(url).toPromise();
  }

  getLayout(crewLayoutID) {
    let url = "/Crew/Timecard/Layout?crewLayoutID=" + crewLayoutID;
    return this.http.get(url).toPromise();
  }

  getLookupValues(crewLayoutDetailID, crewTemplateID, pRPCKeyID) {
    let url = "/Crew/Timecard/GetLookupValues?crewLayoutDetailID=" + crewLayoutDetailID + "&crewTemplateID=" + crewTemplateID + "&pRPCKeyID=" + pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  getPayPeriodDetails(pRPCKeyID, isCrewOrStandard: string) {
    let url = "/Timecard/GetPayPeriodDetails/?prpcKeyID=" + pRPCKeyID + "&isCrewOrStandard=" + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getPayPeriodsByTemplate(template) {
    let url = "/CrewTimecard/GetPayPeriodsByTemplate?crewTemplateID=" + template;
    return this.http.get(url).toPromise();
  }

  getCrews(pRCo, pRGRoup) {
    let url = "/CrewTimecard/GetCrews?PRCo=" + pRCo + "&PRGroup=" + pRGRoup;
    return this.http.get(url).toPromise();
  }

  getCrewMember(pRCRKeyID: number): Promise<ICrewMember[]> {
    return this.http.get<ICrewMember[]>(`/CrewTimecard/GetCrewMember?PRCRKeyID=${pRCRKeyID}`).toPromise();
  }

  getCrewTimecardColumns(crewTemplateID, timecardGroupID) {
    let url = "/CrewTimecard/GetColumns?templateID=" + crewTemplateID + "&timecardGroupId=" + timecardGroupID;
    return this.http.get(url).toPromise();
  }

  getLineTypesByTemplate(crewTemplateID, timecardGroupID) {
    let url = "/CrewTimecard/GetLineTypesByTemplate?templateID=" + crewTemplateID + "&timecardGroupId=" + timecardGroupID;
    return this.http.get(url).toPromise();
  }

  getPhasesByJCJMKeyID(jCJMKeyID, laborOnly) {
    let url = "/Crew/Timecard/GetPhasesByJCJMKeyID?jCJMKeyID=" + jCJMKeyID + "&laborOnly=" + laborOnly;
    return this.http.get(url).toPromise();
  }

  getPREHKeyIDByEmployee(pRCo, employee) {
    let url = "/Employee/GetPREHKeyIDByEmployee?pRCo=" + pRCo + "&employee=" + employee;
    return this.http.get(url).toPromise();
  }

  getQuestions(payPeriod) {
    let url = "/CrewTimecard/GetQuestions?timecardGroupID=" + payPeriod.TimecardGroupID;
    return this.http.get(url).toPromise();
  }

  getRequiredColumns(timecardGroupID) {
    let url = "/Timecard/GetRequiredColumns?timecardGroupID=" + timecardGroupID;
    return this.http.get(url).toPromise();
  }

  getTemplateDays(crewTemplateID) {
    let url = "/CrewTimecard/GetTemplateDays?crewTemplateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getTemplatesByPRPCKeyID(pRPCKeyID, crewTemplateID = null) {
    let url = "/CrewTimecard/GetTemplatesByPRPCKeyID?pRPCKeyID=" + pRPCKeyID;
    if (crewTemplateID != null)
      url += "&templateID=" + crewTemplateID;
    return this.http.get(url).toPromise();
  }

  getTimecardColumns(pRCo, pRGroup, isCrewOrStandard, filterType: string = null) {
    let url = "/Timecard/GetTimecardColumns?&pRCo=" + pRCo + "&pRGroup=" + pRGroup + "&isCrewOrStandard=" + isCrewOrStandard;
    return this.http.get(url).toPromise();
  }

  getPayPeriods(isJobApproval: boolean, payPdStatus: number = null) {
    let url = "/CrewTimecard/PayPeriods?isJobApproval=" + isJobApproval;
    if (payPdStatus != null)
      url += "&payPdStatus=" + payPdStatus;
    return this.http.get(url).toPromise();
  }

  cloneCrewTimecard(cloneFromTemplateID, cloneToTemplateID, cloneFromPRPCKeyID, cloneToPRPCKeyID, isCloneHours, cloneType, dateFromString = null, dateToString = null, employeeList = null, restrictSubmitted = null) {
    let url = "/CrewTimecard/CloneCrewTimecard";
    let postData: any = {
      cloneFromTemplateID: cloneFromTemplateID,
      cloneToTemplateID: cloneToTemplateID,
      cloneFromPRPCKeyID: cloneFromPRPCKeyID,
      cloneToPRPCKeyID: cloneToPRPCKeyID,
      isCloneHours: isCloneHours,
      cloneType: cloneType
    };
    if (dateFromString != null)
      postData.dateFromString = dateFromString;
    if (dateToString != null)
      postData.dateToString = dateToString;
    if (employeeList != null)
      postData.employeeList = employeeList;
    if (restrictSubmitted != null)
      postData.restrictSubmitted = restrictSubmitted;

    return this.http.post(url, postData).toPromise();
  }

  createLineFromClocks(crewTemplateID, employeeString, hQBCKeyID) {
    let url = "/CrewTimecard/CreateLineFromClocks";
    let postData: any = {
      createAsSubmitted: 0,
      crewTemplateID: crewTemplateID,
      employeeString: employeeString,
      hQBCKeyID: hQBCKeyID
    }
    return this.http.post(url, postData).toPromise();
  }

  deleteTemplateData(crewTemplateDataID) {
    let url = "/CrewTimecard/DeleteTemplateData";
    return this.http.post(url, {
      crewTemplateDataID: crewTemplateDataID
    }).toPromise();
  }

  groupTimeEntry(employeeString, clockTimeString, clockAction, pRCo){
    let url = "/Timecard/GroupTimeEntry";
    return this.http.post(url, {
      employeeString: employeeString,
      clockTimeString: clockTimeString,
      clockAction: clockAction,
      pRCo: pRCo
    }).toPromise();
  }

  insertTemplateData(crewLayoutDetailID, crewTemplateID, fieldValue, fieldIdentifier) {
    let url = "/CrewTimecard/InsertTemplateData";
    return this.http.post(url, {
      crewLayoutDetailID: crewLayoutDetailID,
      crewTemplateID: crewTemplateID,
      fieldValue: fieldValue,
      fieldIdentifier: fieldIdentifier
    }).toPromise();
  }

  submitCrewTimecard(crewTemplateID, pRPCKeyID, submittedOnString, employees) {
    let url = "/CrewTimecard/SubmitCrewTimecard";
    return this.http.post(url, { crewTemplateID: crewTemplateID, pRPCKeyID: pRPCKeyID, submittedOnString: submittedOnString, employees: employees }).toPromise();
  }

  submitCrewTimecardEmployee(employee, pRCo, hQBCKeyID, questionRow, pRPCKeyID, crewTemplateID, actionString, submitSignatureStr, submitNoIssues,
    submitIssuesNotes, latitude, longitude, submittedOnString) {
    let url = "/CrewTimecard/SubmitCrewTimecardEmployee";
    let postData: any = {
      employee: employee, pRCo: pRCo, hQBCKeyID: hQBCKeyID, pRPCKeyID: pRPCKeyID, crewTemplateID: crewTemplateID,
      actionString: actionString, submitSignatureStr: submitSignatureStr, submitNoIssues: submitNoIssues, submitIssuesNotes: submitIssuesNotes,
      latitude: latitude, longitude: longitude, submittedOnString: submittedOnString
    };
    if (questionRow != null)
      postData.questionRow = questionRow;
    return this.http.post(url, postData).toPromise();
  }

  unsubmitCrewTimecard(unsubmitData: any) {
    let url = "/Crew/Timecard/UnsubmitCrewTimecard";
    return this.http.post(url, unsubmitData).toPromise();
  }

  getPRCoPRGroup() {
    return this.http.get("/Crew/Timecard/GetPRCoPRGroup").toPromise();
  }

  getEmployees(searchString: string, isTimecard?: boolean, pRCo? : number, pRGroup? : number) {
    let url = "/Timecard/GetEmployees?searchString=" + searchString + "&isTimecard=" + isTimecard + "&PRCo=" + pRCo + "&PRGroup=" + pRGroup;
    return this.http.get(url).toPromise();
  }

  addCrewMember(pRCRKeyID: number, employee: number) {
    let url = "/Crew/Timecard/CrewMemberAdd";
    return this.http.post(url, {
      PRCRKeyID: pRCRKeyID,
      employee: employee
    }).toPromise();
  }

  addEditCrew(pRCRKeyID: number, crew: string, crewDescription: string, pRCo: number, pRGroup: number) {
    let url = "/Crew/Timecard/CrewAddEdit";
    return this.http.post(url, {
      PRCRKeyID: pRCRKeyID,
      crew: crew,
      crewDescription: crewDescription,
      PRCo: pRCo,
      PRGroup: pRGroup
    }).toPromise();
  }

  deleteCrewMember(pRCWKeyID : number) {
    let url = "/Crew/Timecard/CrewMemberDelete";
    return this.http.post(url, {
      PRCWKeyID: pRCWKeyID
    }).toPromise();
  }

  updateLayoutDetails(crewLayoutID: number, stickyColumnCount?: number, stickyJobApprovalCount?: number, description?: string) {
    let url = "/Crew/Timecard/UpdateLayoutDetails";
    return this.http.post(url, {
      crewLayoutID: crewLayoutID,
      stickyColumnCount: stickyColumnCount,
      stickyJobApprovalCount: stickyJobApprovalCount,
      description: description
    }).toPromise();
  }

  updatelayout(layoutUpdateModel: any) {
    let url = "/Crew/Timecard/UpdateLayout";
    return this.http.post(url, {
      layoutUpdateModel: layoutUpdateModel
    }).toPromise();
  }

  getLayoutColumns(){
    let url = "/Crew/Timecard/GetLayoutColumns";
    return this.http.get(url).toPromise();
  }

  deleteLayout(crewLayoutID: number) {
    let url = "/Crew/Timecard/DeleteLayout";
    return this.http.post(url, {
      crewLayoutID: crewLayoutID
     }).toPromise();
  }

  getTemplates(userID: number, crewLayoutID: number) {
    let url = "/CrewTimecard/GetTemplates?userID=" + userID + "&crewLayoutID=" + crewLayoutID ;
    return this.http.get(url).toPromise();
  }

  insertUpdateTemplateHeader(crewTemplateID: number, userKeyID: number,crewLayoutID:number, templateName: string, templateIsActive: boolean, templateCanBeEdited: boolean,  templateIsShared: boolean) {
    let url = "/Crew/Timecard/InsertUpdateTemplateHeader";
    return this.http.post(url, {
      crewTemplateID : crewTemplateID,
      userKeyID: userKeyID,
      crewLayoutID: crewLayoutID,
      templateName : templateName,
      templateIsActive: templateIsActive,
      templateCanBeEdited: templateCanBeEdited,
      templateIsShared: templateIsShared
    }).toPromise();
  }

  deleteTemplateHeader(crewTemplateID: number) {
    let url = "/Crew/Timecard/DeleteTemplateHeader";
    return this.http.post(url, {
      crewTemplateID: crewTemplateID
    }).toPromise();
  }

  getTemplateEmployees() {
    let url = "/Timecard/GetEmployees";
    return this.http.get(url).toPromise();
  }

  getCrewMemberMulti(crewIDs: any[]) {
    let url = "/CrewTimecard/GetCrewMemberMulti";
    return this.http.post(url, { PRCRKeyID: crewIDs }).toPromise();
  }
}
